import React from 'react';
import PropTypes from 'prop-types';

const OUTPUT_TYPE_OPTIONS = [
  {
    value: 'Plain Text',
    title: 'Plain Text',
    description: 'Natural language response without formatting.',
  },
  {
    value: 'Schema',
    title: 'JSON (Structured Data)',
    description: 'For data extraction and parsing. You\'ll define the schema next.',
  },
  {
    value: 'Markdown',
    title: 'Markdown',
    description: 'Formatted text with headers, lists, and styling.',
  },
  {
    value: 'XML',
    title: 'XML',
    description: 'Custom XML structure for integration.',
  },
  {
    value: 'CSV',
    title: 'CSV',
    description: 'Tabular data output for spreadsheets.',
  },
];

const StepOutputType = ({ formData, updateFormData }) => {
  return (
    <div className="wizard-step">
      <div className="step-intro">
        <h3>How should the output be formatted?</h3>
        <p>Select the output format for your generated content.</p>
      </div>

      <div className="radio-group">
        {OUTPUT_TYPE_OPTIONS.map((option) => (
          <label 
            key={option.value} 
            className={`radio-card ${formData.output_type === option.value ? 'selected' : ''}`}
          >
            <input
              type="radio"
              name="output_type"
              value={option.value}
              checked={formData.output_type === option.value}
              onChange={(e) => updateFormData('output_type', e.target.value)}
            />
            <div className="radio-content">
              <span className="radio-title">{option.title}</span>
              <span className="radio-description">{option.description}</span>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

StepOutputType.propTypes = {
  formData: PropTypes.object.isRequired,
  updateFormData: PropTypes.func.isRequired,
};

export default StepOutputType;

